import { Container, Line, ListItem, renderPrompt, Section, UnorderedList } from '~/lib/prompts/prompt-components';
import type { InspectedElement } from '~/lib/stores/workbench';

export function isInspectedImage(name: string): boolean {
  return /\.inspect-element-\d+\.jpeg$/.test(name);
}

export function getInspectedElement(inspectedElement?: InspectedElement): string | undefined {
  if (!inspectedElement) {
    return undefined;
  }

  return renderPrompt(
    <Section name="inspected_element">
      <Container>
        <Line>When analyzing the "{inspectedElement.file.name}" screenshot image, please note these restrictions:</Line>

        <UnorderedList indent>
          <ListItem>Only suggest modifications to HTML tags related to the screenshot</ListItem>

          <ListItem>NEVER suggest changes to parent or sibling elements</ListItem>
        </UnorderedList>
      </Container>

      <Line>Selected element: {`<${inspectedElement.tagName}>`}</Line>

      <Container>
        <Line>CSS selector to identify the element:</Line>

        <Container>
          {'```'}
          {inspectedElement.html}
          {'```'}
        </Container>
      </Container>

      <Line>Pathname of the page: {inspectedElement.pathname}</Line>
    </Section>,
  );
}
